import './BlueLine.css'

const BlueLine = () => {
  return <p  className="below-line"></p>
};

export default BlueLine;
